import ImagePreview from "./Components/ImagePreview";

const initImagePreview = () => {
    const images = Array.from(document.querySelectorAll("[data-image-preview]"));

    images.forEach(imageElement => {
        const filename = imageElement.getAttribute('alt');
        const src = imageElement.getAttribute('src');

        imageElement.addEventListener('click', () => {
            new ImagePreview({
                src, filename
            });
        });
    });
}

(function() {
    initImagePreview();
})();

export default initImagePreview;
